/**
 * Google Analytics Tracking Utility
 * LoafPickle Worldwide, LLC
 */

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

/**
 * Tracks a custom event in Google Analytics
 * @param eventName The name of the event (e.g. 'Home_EnterPit')
 * @param params Optional additional parameters
 */
export const trackEvent = (eventName: string, params: Record<string, any> = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    try {
      window.gtag('event', eventName, {
        ...params,
        send_to: 'G-74V45L87LV'
      });
      
      if (import.meta.env.DEV) {
        console.log(`[Analytics] Tracked: ${eventName}`, params);
      }
    } catch (err) {
      console.error('[Analytics] Failed to track event:', err);
    }
  }
};
